<template>
    <div class="selector_corner">
    </div>
</template>

<script>
export default {
  name: 'Corner',
  props: ['x', 'y'],
  data: () => ({}),
  computed: {}
}
</script>

<style scoped>
    .selector_corner {
        background: url(~@/assets/lines/corner.png);
        width: 250px;
        height: 175px;
    }
</style>



// WEBPACK FOOTER //
// src/components/selector/Corner.vue